module.exports = __webpack_public_path__ + "static/media/friendFinder.02caea41.png";